export default __webpack_public_path__ + "static/media/creed.4883d2ef.jpeg";